var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"field",staticStyle:{"padding-right":"15px"}},[_c('button',{staticClass:"button is-premium is-small",on:{"click":function($event){_vm.openBidModal(_vm.bid.lot_id)}}},[_c('img',{staticClass:"place-bid-icon fontawesome-icon",attrs:{"src":"/static/images/icons/placebid.png"}}),_vm._v("\n        Place Bid")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c58ad4c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Card/Buttons/Lots/BidPlace.vue
// module id = null
// module chunks = 